import React, { useEffect } from 'react';
import { useJwt } from 'react-jwt';
import { useHistory } from 'react-router-dom';

import { ACCOUNT_LOGIN } from '../../constants/urls';
import { CookieKeys, useCookie } from '../../hooks/useCookie';
import LERoute, { LERouteProps } from './LERoute';

export default function AuthenticatedRoute({ children, ...props }: LERouteProps) {
  const history = useHistory();

  const [accessToken] = useCookie<string>(CookieKeys.ACCESS_TOKEN);
  const { isExpired } = useJwt(accessToken || '');
  const isValidToken = !!accessToken && !isExpired;

  useEffect(() => {
    if (!isValidToken) {
      history.push(ACCOUNT_LOGIN);
    }
  }, [isValidToken]);

  return <LERoute {...props}>{isValidToken && children}</LERoute>;
}
